<template lang="pug">
    .battery-container
        .battery
            .battery-outline(:style="{ borderColor: batteryColor }")
                template(v-for="i in 5")
                    .battery-bar(
                        :key="i"
                        :style="{ opacity: i <= filledBars ? 1 : 0, backgroundColor: batteryColor }"
                    )
        span.battery-text(v-if="withText") {{ value }}%
</template>

<script>
export default {
  name: "Battery",
  props: {
    value: {
      type: Number,
      required: true,
    },
    colorPercents: {
      type: Array,
      default: () => [40, 70, 100],
    },
    withText: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    filledBars() {
      if (this.value >= 1 && this.value <= 9) {
        return 1;
      }

      if (this.value >= 10 && this.value <= 39) {
        return 2;
      }

      if (this.value >= 40 && this.value <= 69) {
        return 3;
      }

      if (this.value >= 70 && this.value <= 99) {
        return 4;
      }

      if (this.value === 100) {
        return 5;
      }

      return 0;
    },
    batteryColor() {
      const colors = {
        green: "#00BC7D",
        orange: "#FFB900",
        red: "#EC003F",
      };

      const [warningThreshold, goodThreshold] = this.colorPercents;

      const isGoodLevel = this.value >= goodThreshold;
      const isWarningLevel = this.value >= warningThreshold;

      if (isGoodLevel) {
        return colors.green;
      }

      if (isWarningLevel) {
        return colors.orange;
      }

      return colors.red;
    },
    barWidth() {
      return 5;
    },
    gap() {
      const batteryWidth = 36;
      const sections = 5;
      return (batteryWidth - sections * this.barWidth) / (sections + 1);
    },
  },
  methods: {
    barX(i) {
      return 1 + this.gap + (i - 1) * (this.barWidth + this.gap);
    },
  },
};
</script>

<style lang="stylus" scoped>
.battery-container
    display: flex
    align-items: center
    gap: 6px

.battery
    width: 40px
    height: 16px
    position: relative

.battery-outline
    width: 100%
    height: 100%
    border: 1.2px solid
    border-radius: 4px
    display: flex
    align-items: center
    justify-content: space-between
    padding: 0 1px
    box-sizing: border-box
    gap: 1px

.battery-bar
    width: 5px
    height: 12px
    border-radius: 1px
    transition: opacity 0.2s ease
    flex: 1
    &:first-child
        border-top-left-radius: 3px
        border-bottom-left-radius: 3px
    &:last-child
        border-top-right-radius: 3px
        border-bottom-right-radius: 3px

.battery-text
    font-size: 14px
    font-weight: 500
    min-width: 32px
</style>
